import { ShieldCheck, Award, Globe2 } from "lucide-react";

const stats = [
  { k: "500+", v: "Dossiers accompagnés" },
  { k: "2'400 CHF", v: "Économie moyenne / an" },
  { k: "12 ans", v: "D'expertise LAMal" },
  { k: "98 %", v: "Clients satisfaits" },
];

const trustItems = [
  {
    icon: ShieldCheck,
    title: "Agréé FINMA",
    desc: "Inscrit au registre fédéral des intermédiaires d'assurance.",
  },
  {
    icon: Award,
    title: "100 % indépendant",
    desc: "Aucun lien d'exclusivité avec une compagnie d'assurance.",
  },
  {
    icon: Globe2,
    title: "Couverture nationale",
    desc: "Expertise des barèmes et procédures de tous les cantons suisses.",
  },
];

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="py-24 md:py-32 bg-white border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <img
            src="https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Équipe de conseil en assurance en réunion dans un bureau lumineux"
            className="rounded-xl w-full h-[460px] object-cover border border-slate-200"
            loading="lazy"
          />
        </div>
        <div className="lg:col-span-7">
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-spi-red mb-4">
            Confiance & expertise
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-spi-blue font-bold">
            Un partenaire de confiance pour vos décisions de santé.
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed">
            Vous ne payez rien&nbsp;: notre accompagnement est gratuit, neutre
            et sans engagement.
          </p>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6 border-y border-slate-200 py-8">
            {stats.map((s) => (
              <div key={s.k}>
                <div className="font-display text-2xl text-spi-blue font-bold">{s.k}</div>
                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1 font-medium">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {trustItems.map((t) => (
              <div key={t.title}>
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-spi-blue/5">
                  <t.icon className="w-5 h-5 text-spi-blue" strokeWidth={1.75} />
                </div>
                <div className="mt-3 font-semibold text-spi-blue">{t.title}</div>
                <div className="text-sm text-slate-600 mt-1">{t.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
